import "./NotAccess.scss"
import {useNavigate} from "react-router-dom";
import {RouteHelper} from "../../route/RouteHelper";
import notFoundImage from "./403_Error.svg";
import {RaikoButtonPrimary} from "@moeindal/base-raiko-panel-components";

export default function NotAccess() {

    const navigate = useNavigate()

    function handleGoDashboard() {
        navigate(RouteHelper.Dashboard.globalUrl)
    }


    return (
        <div className={"baseNotFoundPageStyle"}>
            <div className={"notFoundItemsContainer"}>
                <img src={notFoundImage} alt=""/>
                <span className={"notFoundTitle"}>دسترسی شما به این صفحه محدود شده است</span>
                <span
                    className={"notFoundSubtitle"}>لطفا برای اطلاعات بیشتر با مدیر سیستم خود ارتباط برقرار نمایید.</span>
                <RaikoButtonPrimary label={"صفحـه اصلی"} onClick={handleGoDashboard}/>
            </div>
        </div>
    )
}
